import React from 'react'
import { Navbar } from './components/Navbar'
import { AppRouter } from './router/AppRouter'

export const App = () => {
  return (
    <div>
      <AppRouter />
    </div>
  )
}
